var _circle, _path, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1218_127)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7773 35.1969C31.161 35.446 30.8884 36.3996 31.2679 36.9788C31.365 37.127 32.0293 37.6659 32.7441 38.1766C35.6715 40.2679 37.4748 42.0417 39.1577 44.4854C41.3039 47.6017 42.9891 51.5362 44.1239 56.08C45.2653 60.65 46.0059 67.1867 46.0126 72.7525C46.0144 74.1133 46.1347 74.4893 46.6547 74.7583C47.0528 74.9642 47.3373 74.9642 47.7354 74.7583C48.2643 74.4847 48.3422 74.1816 48.4245 72.0762C48.8538 61.0965 51.8283 53.2388 57.7339 47.4838C59.7527 45.5164 61.8887 44.018 64.6705 42.6177C65.604 42.1478 65.7678 41.9606 65.7678 41.3638C65.7678 40.9668 65.7091 40.8137 65.4618 40.5666C64.9142 40.0188 64.5197 40.0345 63.2444 40.6546C58.8588 42.7868 54.6737 46.479 51.9658 50.6048C50.8787 52.2612 50.2094 53.4621 49.5171 54.999C48.8637 56.4495 48.087 58.6385 47.788 59.8722C47.6832 60.3047 47.5623 60.6187 47.5194 60.5701C47.4764 60.5214 47.3577 59.9743 47.2556 59.3544C46.3048 53.5807 44.166 47.663 41.6178 43.7551C39.6411 40.7239 37.7492 38.785 34.4196 36.3786C32.5297 35.0126 32.389 34.9498 31.7773 35.1969Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1218_127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0243 27.6868C47.6558 31.2511 46.2352 40.5876 44.4459 44.8103C43.7128 47.1292 40.5261 48.7825 39.0243 49.3192C28.2887 52.2393 23.7081 44.846 22.7598 40.7844C21.0421 36.7907 20.8989 29.2793 21.0421 26.0228C20.9991 25.4645 21.5252 25.1103 21.7936 25.0029C31.241 24.917 37.2172 26.7564 39.0243 27.6868Z",
    fill: "url(#paint1_linear_1218_127)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0243 27.6868C47.6558 31.2511 46.2352 40.5876 44.4459 44.8103C43.7128 47.1292 40.5261 48.7825 39.0243 49.3192C28.2887 52.2393 23.7081 44.846 22.7598 40.7844C21.0421 36.7907 20.8989 29.2793 21.0421 26.0228C20.9991 25.4645 21.5252 25.1103 21.7936 25.0029C31.241 24.917 37.2172 26.7564 39.0243 27.6868Z",
    stroke: "url(#paint2_linear_1218_127)",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1218_127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.1944 27.6868C51.5629 31.2511 52.9836 40.5876 54.7729 44.8103C55.506 47.1292 58.6927 48.7825 60.1944 49.3192C70.9301 52.2393 75.5107 44.846 76.459 40.7844C78.1767 36.7907 78.3198 29.2793 78.1767 26.0228C78.2196 25.4645 77.6936 25.1103 77.4252 25.0029C67.9778 24.917 62.0016 26.7564 60.1944 27.6868Z",
    fill: "url(#paint3_linear_1218_127)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1944 27.6868C51.5629 31.2511 52.9836 40.5876 54.7729 44.8103C55.506 47.1292 58.6927 48.7825 60.1944 49.3192C70.9301 52.2393 75.5107 44.846 76.459 40.7844C78.1767 36.7907 78.3198 29.2793 78.1767 26.0228C78.2196 25.4645 77.6936 25.1103 77.4252 25.0029C67.9778 24.917 62.0016 26.7564 60.1944 27.6868Z",
    stroke: "url(#paint4_linear_1218_127)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1218_127",
    x: 18.85,
    y: 22.85,
    width: 29.0969,
    height: 29.2844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1218_127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1218_127",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1218_127",
    x: 51.2719,
    y: 22.85,
    width: 29.0969,
    height: 29.2844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1218_127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1218_127",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1218_127",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1218_127",
    x1: 43.1433,
    y1: 27.3051,
    x2: 16.2934,
    y2: 41.1031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1218_127",
    x1: 31.3321,
    y1: 29.1641,
    x2: 21.914,
    y2: 50.9743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1218_127",
    x1: 56.0754,
    y1: 27.3051,
    x2: 82.9254,
    y2: 41.1031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1218_127",
    x1: 67.8867,
    y1: 29.1641,
    x2: 77.3048,
    y2: 50.9743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4);
export default __webpack_public_path__ + "static/media/p4.a778503b6d7dd4f39c67327bc8623aec.svg";
export { ForwardRef as ReactComponent };